import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-32 overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=artisan%20craftsman%20hands%20stitching%20premium%20leather%20bag%20close%20up%20detail%20dramatic%20dark%20moody%20lighting%20workshop%20atmosphere&width=1920&height=800&seq=cta1&orientation=landscape"
        alt="Craftsmanship"
        className="absolute inset-0 w-full h-full object-cover object-top"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/70" />

      <div className="relative z-10 max-w-4xl mx-auto px-6 md:px-10 text-center">
        <span className="inline-block text-amber-400 text-xs font-semibold tracking-widest uppercase mb-6 border border-amber-400/40 rounded-full px-4 py-1.5">
          Experience Craftsmanship
        </span>
        <h2 className="text-4xl md:text-6xl font-bold text-white leading-tight mb-6 tracking-tight">
          EVERY STITCH TELLS<br />A STORY OF QUALITY
        </h2>
        <p className="text-white/70 text-base md:text-lg leading-relaxed mb-10 max-w-2xl mx-auto">
          From raw material selection to final inspection, our commitment to excellence is woven into every product we create. Partner with us and experience the Yunxin difference.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/contact"
            className="inline-flex items-center justify-center gap-3 bg-amber-600 hover:bg-amber-500 text-white px-8 py-4 rounded-full text-sm font-semibold tracking-widest uppercase transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            <div className="w-5 h-5 flex items-center justify-center">
              <i className="ri-mail-send-line" />
            </div>
            Get In Touch
          </Link>
          <Link
            to="/products"
            className="inline-flex items-center justify-center gap-2 bg-white/10 border border-white/30 hover:bg-white/20 text-white px-8 py-4 rounded-full text-sm font-semibold tracking-widest uppercase transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            Browse Products
          </Link>
        </div>
      </div>
    </section>
  );
}
